module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/Users/noahmoss/metabase-releases/release-2023-07-17/46-ee/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!/Users/noahmoss/metabase-releases/release-2023-07-17/46-ee/node_modules/source-map-loader/dist/cjs.js!/Users/noahmoss/metabase-releases/release-2023-07-17/46-ee/frontend/src/metabase-lib/metadata/utils/ga-metadata.js"));
    });
  });
}